// extracted by mini-css-extract-plugin
module.exports = {"wrap":"pagination_wrap__vbMqR","tip_text":"pagination_tip_text__Qd3kg"};